import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link, useParams } from 'react-router-dom';
import { featuredArticles, hotArticles } from '@/mocks/homeData';
import { useEffect, useState } from 'react';

const articleContents: Record<string, { intro: string; details: string[]; conclusion: string }> = {
  'star-gossip': {
    intro: '娱乐圈从来不缺爆料，但这次的消息着实让吃瓜群众们坐不住了。',
    details: [
      '据悉，此事最早由一位匿名网友在社交平台曝光。该网友自称与当事人有密切往来，手中握有大量未公开的证据材料。消息一出，迅速在各大社交平台引发热议，相关话题在短短两小时内阅读量突破千万。',
      '吃瓜网记者从多方渠道核实，事件的导火索可以追溯到数月之前。一位不愿透露姓名的圈内人士向吃瓜网透露："这件事圈内其实早有风声，只是一直没人敢公开说。这次终于有人站出来爆料，也算是给大家一个交代。"',
      '值得注意的是，事件涉及的各方目前均已获悉此事。据接近当事人的消息源透露，相关方正在紧急商讨应对方案。某知名公关公司已被紧急聘请，预计很快会有官方声明发布。',
      '吃瓜网梳理发现，该事件背后涉及的利益关系错综复杂。从商业代言到影视项目，从个人形象到团队利益，每一环都牵动着巨大的商业价值。这也解释了为何各方在面对爆料时表现得如此谨慎。',
    ],
    conclusion: '截至目前，当事人及相关方面尚未就此事做出正式回应。吃瓜网将持续关注事件进展，为读者带来最新、最全面的报道。在真相水落石出之前，我们呼吁大家理性吃瓜，不传播未经证实的信息。',
  },
  'influencer-fails': {
    intro: '网红经济的泡沫正在一个接一个地破灭，这一次翻车的，是拥有千万粉丝的顶流级人物。',
    details: [
      '事情的起因源于一位职业打假人的爆料。该打假人在直播中当场测试了该网红推荐的产品，结果发现多项指标与宣传严重不符。更令人震惊的是，产品包装上的认证标识经核实系伪造。',
      '随着事件发酵，越来越多的消费者站出来分享自己的使用体验。一位购买了该产品的消费者告诉吃瓜网："用了之后不仅没有效果，反而出现了过敏反应。联系客服要求退款，却被各种推诿。"目前，已有超过500名消费者联名向消费者协会投诉。',
      '业内人士分析指出，这起事件只是网红带货乱象的冰山一角。"很多网红为了高额佣金，根本不关心产品质量。有些甚至在明知产品有问题的情况下仍然大力推荐，完全把粉丝当韭菜收割。"该业内人士表示。',
      '平台方面已对该网红账号做出限制处理，相关带货视频已被下架。据悉，该网红与品牌方的合作合约中涉及高额违约金条款，此次事件可能导致其面临数千万元的赔偿。',
    ],
    conclusion: '翻车事件再次给整个行业敲响警钟。在流量为王的时代，网红们不能只顾着赚快钱，更要对自己的推荐负责。吃瓜网也将持续关注此事的后续发展，为消费者维权发声。',
  },
  'edgy-content': {
    intro: '这条消息来得太突然，以至于很多吃瓜群众第一反应都是"这是真的假的？"',
    details: [
      '据知情人士向吃瓜网独家透露，事件的核心人物在整个娱乐圈都有着举足轻重的地位。正因为如此，当爆料内容在深夜悄然流出时，整个互联网都沸腾了。',
      '有网友迅速整理了事件的时间线和关键证据链。从最初的蛛丝马迹到如今的实锤曝光，整个过程堪称一部悬疑大片。吃瓜网发现，早在半年前就有网友在评论区预测过类似的情节，当时被众人嘲笑是"脑洞太大"，如今看来竟是神预言。',
      '此事涉及的隐私和法律问题也引发了广泛讨论。有法律界人士指出，如果爆料内容属实，涉事方可能面临严重的法律后果。但同时也强调，在官方调查结果出来之前，不应过早给出定论。',
      '多位圈内人士在私下向吃瓜网表达了对此事的看法。有人表示震惊，有人表示"早有耳闻"，还有人选择沉默。这种复杂的反应态度，本身就很耐人寻味。',
    ],
    conclusion: '这个瓜的含金量仍在持续上升中。吃瓜网将继续深入追踪，为读者还原最接近真相的全貌。提醒各位吃瓜群众：理性吃瓜，不信谣不传谣，等待官方说法。',
  },
  'classic': {
    intro: '有些瓜，即便时隔多年，依然能让人回味无穷。今天我们就来重温一个足以载入娱乐圈史册的经典事件。',
    details: [
      '事件最初爆发于社交媒体上的一条匿名投稿。当时没有人能预料到，这条看似普通的爆料，会在接下来的几个月里演变成一场席卷整个娱乐圈的地震级事件。',
      '回看当时的报道，吃瓜网是最早介入报道的媒体之一。我们的记者团队夜以继日地追踪事件进展，发布了超过30篇深度追踪报道，累计阅读量突破亿级。很多后来被全网引用的关键证据，都是吃瓜网独家首发的。',
      '事件的高潮出现在爆料后的第三个月。当所有人都以为风波即将平息时，一位重磅知情人突然站出来，公开了足以颠覆整个事件走向的关键证据。那一天，吃瓜网的服务器差点被涌来的流量挤爆。',
      '如今回望，这个事件不仅改变了当事人的命运，更深刻影响了整个娱乐圈的生态。它让更多人意识到，在聚光灯下光鲜亮丽的明星们，背后可能隐藏着不为人知的另一面。',
    ],
    conclusion: '经典之所以成为经典，是因为它的影响力超越了事件本身。对于后来者来说，这既是一面镜子，也是一个警示。吃瓜网将继续守护这份"瓜田记忆"，让每一个经典不被遗忘。',
  },
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const allArticles = [...featuredArticles, ...hotArticles];
  const article = allArticles.find(a => a.id === id);

  const [shareTooltip, setShareTooltip] = useState('');

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShareTooltip('链接已复制！');
    } catch {
      setShareTooltip('复制失败');
    }
    setTimeout(() => setShareTooltip(''), 2000);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [id]);

  useEffect(() => {
    if (!article) return;

    const categorySlug = (article as any).categorySlug || 'star-gossip';
    const categoryName = (article as any).category || '明星八卦';

    const articleSchema = {
      '@context': 'https://schema.org',
      '@type': 'Article',
      'headline': article.title,
      'description': article.excerpt || article.title,
      'datePublished': article.date,
      'dateModified': article.date,
      'author': { '@type': 'Organization', 'name': '吃瓜网编辑部', 'url': 'https://www.chiguawang.com' },
      'publisher': { '@type': 'Organization', 'name': '吃瓜网', 'url': 'https://www.chiguawang.com' },
      'image': article.imageUrl || '',
      'mainEntityOfPage': { '@type': 'WebPage', '@id': `https://www.chiguawang.com/article/${article.id}` },
      'about': { '@type': 'Thing', 'name': categoryName },
      'inLanguage': 'zh-CN',
    };

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://www.chiguawang.com' },
        { '@type': 'ListItem', 'position': 2, 'name': categoryName, 'item': `https://www.chiguawang.com/category/${categorySlug}` },
        { '@type': 'ListItem', 'position': 3, 'name': article.title },
      ],
    };

    const scripts = [
      { id: 'article-schema', data: articleSchema },
      { id: 'article-breadcrumb-schema', data: breadcrumbSchema },
    ];

    scripts.forEach(({ id: sid, data }) => {
      const existing = document.getElementById(sid);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = sid;
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
    });

    return () => {
      scripts.forEach(({ id: sid }) => {
        const el = document.getElementById(sid);
        if (el) el.remove();
      });
    };
  }, [article]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16 md:pt-18 min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center px-4">
            <div className="w-20 h-20 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-6">
              <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
            </div>
            <p className="text-foreground-700 font-heading text-lg mb-2">文章未找到</p>
            <p className="text-foreground-400 text-sm mb-6">这篇文章可能已被删除或链接失效</p>
            <Link
              to="/"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-home-line"></i> 返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categorySlug = (article as any).categorySlug || 'star-gossip';
  const categoryName = (article as any).category || '明星八卦';
  const contentData = articleContents[categorySlug] || articleContents['star-gossip'];

  const relatedArticles = allArticles
    .filter(a => a.id !== id && (a as any).categorySlug === categorySlug)
    .slice(0, 3);

  if (relatedArticles.length < 3) {
    const others = allArticles.filter(a => a.id !== id && (a as any).categorySlug !== categorySlug).slice(0, 3 - relatedArticles.length);
    relatedArticles.push(...others);
  }

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18 bg-background-50">
        {/* Breadcrumb Bar */}
        <div className="px-4 md:px-6 py-3 bg-background-100 border-b border-secondary-200/50">
          <div className="max-w-4xl mx-auto">
            <nav className="flex items-center gap-1.5 text-xs text-foreground-400 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to={`/category/${categorySlug}`} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {categoryName}
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-600 truncate max-w-[180px] md:max-w-[300px]">{article.title}</span>
            </nav>
          </div>
        </div>

        {/* Article Content */}
        <article className="py-8 md:py-10 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <header className="mb-8">
              {/* Category + Tag */}
              <div className="flex items-center gap-2 mb-4 flex-wrap">
                <Link
                  to={`/category/${categorySlug}`}
                  className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium hover:bg-secondary-200 transition-colors cursor-pointer"
                >
                  {categoryName}
                </Link>
                {article.tag && (
                  <span className="px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
                    {article.tag}
                  </span>
                )}
              </div>

              {/* Title */}
              <h1 className="font-heading text-2xl md:text-3xl lg:text-[2rem] text-foreground-950 leading-snug mb-5">
                {article.title}
              </h1>

              {/* Meta */}
              <div className="flex flex-wrap items-center gap-3 md:gap-5 text-foreground-400 text-xs md:text-sm">
                <span className="flex items-center gap-1.5">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-user-line text-primary-500 text-xs"></i>
                  </div>
                  吃瓜网编辑部
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line text-foreground-300"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line text-foreground-300"></i>
                  {(article.views / 10000).toFixed(0)}万 阅读
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line text-foreground-300"></i>
                  {article.comments.toLocaleString()} 评论
                </span>
              </div>
            </header>

            {/* Featured Image */}
            {article.imageUrl && (
              <div className="rounded-2xl overflow-hidden mb-10">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-auto object-cover"
                />
              </div>
            )}

            {/* Content Body */}
            <div className="text-foreground-700 leading-relaxed text-[15px] md:text-base">
              {/* Excerpt / Lead */}
              <p className="text-foreground-900 font-medium text-lg leading-relaxed mb-8 border-l-4 border-primary-400 pl-5 py-1">
                {article.excerpt || article.title}
              </p>

              {/* Generated Content */}
              <p className="mb-6">{contentData.intro}</p>

              {contentData.details.map((paragraph, idx) => (
                <p key={idx} className="mb-6">{paragraph}</p>
              ))}

              <p className="mb-8">{contentData.conclusion}</p>

              {/* Disclaimer */}
              <div className="bg-secondary-50 border border-secondary-200/60 rounded-2xl p-5 md:p-6 my-10">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-secondary-600 text-sm"></i>
                  </div>
                  <div>
                    <p className="text-foreground-800 text-sm font-semibold mb-1">免责声明</p>
                    <p className="text-foreground-500 text-sm leading-relaxed">
                      本文内容来源于用户投稿及网络公开信息整理，吃瓜网不对内容的真实性做绝对保证。
                      如有不实之处，请相关方通过官方渠道联系我们进行澄清或删除。
                    </p>
                  </div>
                </div>
              </div>

              {/* Article Stats */}
              <div className="flex flex-wrap items-center justify-between gap-4 py-6 border-t border-secondary-200/50">
                <div className="flex items-center gap-6">
                  <button className="flex items-center gap-1.5 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-thumb-up-line text-lg"></i>
                    <span className="text-sm">{(article.views * 0.03).toFixed(0)}</span>
                  </button>
                  <button className="flex items-center gap-1.5 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-thumb-down-line text-lg"></i>
                  </button>
                  <button className="flex items-center gap-1.5 text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">
                    <i className="ri-star-line text-lg"></i>
                    <span className="text-sm">收藏</span>
                  </button>
                </div>
                <div className="flex items-center gap-2 relative">
                  <span className="text-foreground-400 text-xs">分享到：</span>
                  <button
                    onClick={() => window.open(`https://service.weibo.com/share/share.php?url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(article.title)}`, '_blank')}
                    className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer"
                    aria-label="分享到微博"
                  >
                    <i className="ri-weibo-line"></i>
                  </button>
                  <button
                    className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-foreground-500 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer"
                    aria-label="分享到微信"
                    onClick={() => setShareTooltip(shareTooltip ? '' : '请截图后通过微信分享')}
                  >
                    <i className="ri-wechat-line"></i>
                  </button>
                  <button
                    onClick={handleCopyLink}
                    className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-foreground-500 hover:bg-secondary-200 transition-colors cursor-pointer"
                    aria-label="复制链接"
                  >
                    <i className="ri-link"></i>
                  </button>
                  {shareTooltip && (
                    <span className="absolute -top-9 right-0 px-3 py-1.5 rounded-lg bg-foreground-800 text-white text-xs whitespace-nowrap">
                      {shareTooltip}
                    </span>
                  )}
                </div>
              </div>

              {/* Tags */}
              <div className="flex flex-wrap items-center gap-2 pt-4 border-t border-secondary-200/50">
                <span className="text-foreground-400 text-xs">标签：</span>
                <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-foreground-600 text-xs cursor-pointer hover:bg-secondary-200 transition-colors">{categoryName}</span>
                <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-foreground-600 text-xs cursor-pointer hover:bg-secondary-200 transition-colors">爆料</span>
                <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-foreground-600 text-xs cursor-pointer hover:bg-secondary-200 transition-colors">吃瓜</span>
                <span className="px-3 py-1.5 rounded-full bg-secondary-100 text-foreground-600 text-xs cursor-pointer hover:bg-secondary-200 transition-colors">{categoryName}</span>
              </div>
            </div>
          </div>
        </article>

        {/* Related Articles */}
        {relatedArticles.length > 0 && (
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950">相关爆料</h2>
                <Link
                  to={`/category/${categorySlug}`}
                  className="text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
                >
                  查看更多 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="group bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-40 overflow-hidden">
                      <img
                        src={ra.imageUrl || ''}
                        alt={ra.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                        {ra.title}
                      </h3>
                      <div className="flex items-center justify-between text-foreground-400 text-xs">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i> {(ra.views / 10000).toFixed(0)}万
                        </span>
                        <span>{ra.date}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Bottom Nav: Prev / Next */}
        <div className="px-4 md:px-6 pb-10 md:pb-14">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-between">
              <Link
                to="/"
                className="flex items-center gap-2 text-foreground-500 text-sm hover:text-primary-500 transition-colors py-3 cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i> 返回首页
              </Link>
              <Link
                to={`/category/${categorySlug}`}
                className="flex items-center gap-2 text-foreground-500 text-sm hover:text-primary-500 transition-colors py-3 cursor-pointer"
              >
                更多{categoryName} <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}